<template>
  <div class="s-layout" :style="colorObject">
    <div class="s-container">
      <Header
        :page-title="getModuleConfig('page_title')"
        :page-image="getModuleConfig('page_image')"
        :page-kv-image="getModuleConfig('page_kv_image')"
        :header-section="getModuleConfig('header_section')"
        :meta="meta"
      ></Header>
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { themeColorFn } from "@/mixins/liff/themeColor";
import workerMixin from "@/mixins/liff/worker";
import Header from "@/components/Page/Liff/Shared/HeaderV3";

const MODULE_CODE = "liff_form";

export default {
  components: {
    Header,
  },
  mixins: [themeColorFn({ themeConfigPage: "form" }), workerMixin],
  computed: {
    ...mapGetters({
      meta: "liffGeneral/meta",
    }),
  },
  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"](MODULE_CODE, key);
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/css/liff/main.css";
@import "../../../assets/css/liff/liff_init_theme_config.css";

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
  --s-danger: #fe0000;
}

.s-container {
  min-height: 100vh;
}

.page {
  padding: 16px 12px;
  background: var(--liff-content_bg_color);

  &__title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    margin-top: 0 !important;
    margin-bottom: 16px !important;
    text-align: center;
    color: var(--liff-primary_text_color) !important;
  }

  &__desc {
    font-size: 14px;
    line-height: 22px;
    color: var(--liff-secondary_text_color) !important;
    margin-top: 0;
    margin-bottom: 16px !important;
    text-align: center;

    b {
      color: var(--primary-color) !important;
      font-weight: 600;
    }
  }

  &__button {
    padding: 12px;
    color: var(--liff-primary_text_color) !important;
  }
}
</style>

<style>
.page__content {
  border: 1px solid #cccccc;
  border-radius: 10px;
  padding: 5px 10px !important;
  margin: 0 !important;
  box-shadow: rgb(from var(--liff-primary_text_color) r g b/.5) 0 2px 5px 0;
}
</style>

